var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Test "),_c('div',[_c('PicturePool')],1),_c('div',{staticStyle:{"margin":"20px"}},[_c('h2',[_vm._v("Hotels in die DB Speichern")]),_c('br'),_c('v-btn',{on:{"click":_vm.getHalalHotel}},[_vm._v("Speichern")]),_c('br'),_c('v-btn',{on:{"click":_vm.addFacalities}},[_vm._v("facalities save")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }